'use strict';

angular.module('app.serverTimeService', [])
    .factory('serverTime', [
        function () {
            return {
                value: null,
                unix: null,
                set: function (time) {
                    this.unix = time;
                    return this.value = moment.unix(time);
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/serverTimeService.js